import React from 'react';
import { LockClosedIcon } from '@heroicons/react/24/outline';
import { Role, ROLE_DETAILS, useAuth } from '../state/AuthContext';

interface RoleGateProps {
  allowedRoles: Role[];
  children: React.ReactNode;
}

const RoleGate: React.FC<RoleGateProps> = ({ allowedRoles, children }) => {
  const { role } = useAuth();
  const isAllowed = role ? allowedRoles.includes(role) : false;

  if (isAllowed) {
    return <>{children}</>;
  }

  const allowedLabels = allowedRoles.map((allowedRole) => ROLE_DETAILS[allowedRole].label);

  return (
    <div className="glass-panel mx-auto mt-20 max-w-3xl space-y-4 p-10 text-center">
      <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-blue/10 text-brand-blue">
        <LockClosedIcon className="h-7 w-7" />
      </div>
      <h2 className="text-2xl font-semibold text-slate-900">Restricted area</h2>
      <p className="text-sm text-slate-500">
        This module is reserved for{' '}
        <span className="font-semibold text-slate-900">{allowedLabels.join(' or ')}</span>. Use the
        role switcher in the header to preview their workflow.
      </p>
    </div>
  );
};

export default RoleGate;
